import React, { useMemo } from 'react';
import { sanitizeHtml } from '../../utils/html/sanitizeHtml';

interface SafeHtmlContentProps {
  htmlContent?: string;
  fallbackText?: string;
  className?: string;
}

const SafeHtmlContent: React.FC<SafeHtmlContentProps> = ({
  htmlContent,
  fallbackText = 'No hay informacion disponible.',
  className,
}) => {
  const sanitizedHtml = useMemo(() => sanitizeHtml(htmlContent ?? ''), [htmlContent]);

  if (!htmlContent || htmlContent.trim() === '') {
    return <span>{fallbackText}</span>;
  }

  return <div className={className} dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
};

export default SafeHtmlContent;
